module.exports = __webpack_public_path__ + "static/media/screen5.ff746227.png";